import React from "react";
import FieldLabel from "../../../components/label";
import ChipSelect from "../../../components/chipSelect";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { Box, TextField } from "@mui/material";

function NomineeMobileDetails({
  classes: { borderBgColorContainer, formGroup },
  errorMessage,
  form,
  handleChange,
  handleChangeChipSelect,
  options,
  validateInputLength,
}) {
  return (
    <Box className={borderBgColorContainer} p={1}>
      <Box className={formGroup} pt={0}>
        <FieldLabel label={"Nominee Mobile Available*"} />
        <ChipSelect
          fieldname={"nominee_mobile_available"}
          handleChange={handleChangeChipSelect}
          options={options.availableOrNot}
          selectedItem={form.nominee_mobile_available}
          isMinWidth={true}
        />
      </Box>

      {form.nominee_mobile_available === "Available" && (
        <>
          <Box className={formGroup} pt={0} pb={0}>
            <FieldLabel label={"Mobile same as the Owner of the Policy*"} />
            <ChipSelect
              fieldname={"nominee_mobile_same_as_owner"}
              handleChange={handleChangeChipSelect}
              options={options.sameOrDifferent}
              selectedItem={form.nominee_mobile_same_as_owner}
              isMinWidth={true}
            />
          </Box>

          {form.nominee_mobile_same_as_owner === "Different" && (
            <Box className={formGroup} pt={0}>
              <FieldLabel label={"Nominee Mobile*"} />
              <TextField
                id="standard-basic"
                variant="outlined"
                value={form.nominee_mobile}
                name="nominee_mobile"
                onInput={validateInputLength}
                onChange={handleChange}
                autoComplete="off"
                helperText={errorMessage.nominee_mobile}
                fullWidth
              />
            </Box>
          )}
        </>
      )}
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(NomineeMobileDetails);
